// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + (chunkId === 679 ? "semtalkapp" : chunkId) + "." + {"679":"4db18de0","690":"5dd221d9"}[chunkId] + ".chunk.js");